/**
 * أدوات السوق — النصوص العربية.
 *
 * قواعد الصياغة (التزامات منتج، وليست تفضيلات أسلوب):
 *  - ثلاثة مواضع محايدة فقط للسعر: ضمن النطاق / أعلى من معظم الصفقات / أقل من معظم الصفقات.
 *    لا «مبالغ فيه»، ولا «صفقة»، ولا «سعر عادل».
 *  - كل رقم نطاق مبني على صفقات مسجّلة فعلاً، ويُذكر عدد الصفقات والفترة بجانبه.
 *  - «مؤشر إحصائي استرشادي — ليس تقييماً» على كل نتيجة فيها سعر.
 */
const marketTools = {
  page: {
    eyebrow: 'بيانات السوق',
    title: 'أدوات السوق',
    subtitle:
      'اختر حيّاً أو اكتب مساحتك، واحصل على إجابة مبنية على الصفقات العقارية المسجّلة لدى وزارة العدل.',
    disclaimer: 'مؤشر إحصائي استرشادي - ليس تقييماً',
    unavailable: {
      title: 'الأدوات غير متاحة حالياً',
      body: 'بيانات السوق غير محمّلة على الخادم الآن. جرّب لاحقاً.',
    },
    stats: {
      districts: 'حي',
      cities: 'مدينة',
      deeds: 'صفقة مسجّلة',
      updated: 'آخر تحديث',
    },
  },

  // حالة «التحليل» — خطوات حقيقية يقوم بها النموذج، لا زينة
  analysing: {
    twins: [
      'قراءة بيانات {{districts}} حي…',
      'مقارنة الخصائص: المساحات، النشاط، الاتجاه، الخدمات القريبة…',
      'ترتيب الأحياء الأقرب شبهاً…',
      'استبعاد الأغلى والاحتفاظ بالأرخص…',
    ],
    size: [
      'تحديد الحي…',
      'اختيار شريحة المساحة المطابقة…',
      'حساب نطاق سعر المتر من الصفقات المسجّلة…',
    ],
    month: ['قراءة تواريخ الصفقات…', 'إزالة أثر نمو السوق بين السنوات…', 'حساب نشاط كل شهر…'],
  },

  common: {
    how: 'كيف تُحسب؟',
    city: 'المدينة',
    district: 'الحي',
    chooseCity: 'اختر المدينة',
    chooseDistrict: 'اختر الحي',
    propertyType: 'نوع العقار',
    perM2: 'ريال / م²',
    sar: 'ريال',
    deeds_one: 'صفقة واحدة',
    deeds_two: 'صفقتان',
    deeds_few: '{{count}} صفقات',
    deeds_many: '{{count}} صفقة',
    deeds_other: '{{count}} صفقة',
    basedOn: 'بناءً على {{count}} صفقة مسجّلة',
    source: 'المصدر: وزارة العدل - الصفقات المسجّلة',
    tryAgain: 'جرّب مرة أخرى',
    change: 'تغيير',
    noData: 'بيانات غير كافية',
    noDataBody: 'لا توجد صفقات مسجّلة كافية في هذا الحي لإعطاء إجابة موثوقة. اختر حيّاً آخر.',
    districtUnknown: 'لم نتعرّف على هذا الحي',
    districtUnknownBody: 'اختر الحي من القائمة حتى نطابقه مع بيانات الصفقات.',
    segments: {
      apartment: 'شقق',
      res_land: 'أراضٍ سكنية',
      com_land: 'أراضٍ تجارية',
    },
  },

  // ١ — الأحياء الشبيهة
  twins: {
    name: 'أحياء شبيهة وأقل سعراً',
    tagline: 'اختر حيّاً، ونعرض لك أحياء تشبهه في طبيعته لكن سعرها أقل.',
    cta: 'اعرض الأحياء الشبيهة',
    ctaAgain: 'ابحث عن حي آخر',
    howItWorks:
      'نقارن كل حي بغيره في المساحات المعتادة، حجم النشاط، اتجاه الأسعار، وقربه من المترو والمدارس والحدائق - ثم نستبعد الأغلى. السعر نفسه ليس جزءاً من المقارنة، وإلا لأعاد لك أحياءً بنفس السعر.',
    originTitle: 'الحي الذي اخترته',
    resultsTitle: 'أحياء تشبهه وأقل سعراً',
    resultsCount: '{{count}} حي',
    cheaperBy: 'أقل بـ {{pct}}%',
    medianLabel: 'وسيط سعر المتر',
    why: 'لماذا يشبهه؟',
    reasons: {
      size: 'مساحات متقاربة',
      activity: 'نشاط بيع متقارب',
      trend: 'اتجاه أسعار واحد',
      metro: 'كلاهما قرب المترو',
      schools: 'مدارس قريبة',
      parks: 'حدائق قريبة',
      malls: 'مراكز تجارية قريبة',
      profile: 'أقرب تطابق في مجمل الخصائص',
    },
    momentum: {
      rising: 'أسعاره صاعدة',
      falling: 'أسعاره نازلة',
      steady: 'أسعاره مستقرة',
      unclear: 'اتجاهه غير واضح',
    },
    viewListings: 'تصفّح إعلانات هذا الحي',
    empty: 'لا يوجد حي أرخص يشبه هذا الحي بدرجة كافية.',
  },

  // ٢ — سعر المتر حسب المساحة
  size: {
    name: 'سعر المتر لمساحتك',
    tagline: 'اكتب المساحة، ونعرض لك ما سجّلته فعلاً العقارات بهذا الحجم في الحي.',
    cta: 'احسب النطاق',
    ctaAgain: 'احسب مرة أخرى',
    howItWorks:
      'سعر المتر لا يسير في خط مستقيم مع المساحة - القطع الصغيرة عادةً أغلى للمتر الواحد. لذلك نقسّم صفقات الحي إلى شرائح حسب المساحة، ونعرض الشريحة التي تقع فيها مساحتك.',
    areaLabel: 'المساحة (م²)',
    areaPlaceholder: 'مثال: 437',
    priceLabel: 'السعر المطلوب (اختياري)',
    pricePlaceholder: 'مثال: 1,250,000',
    priceHint: 'أضف السعر لتعرف أين يقع ضمن النطاق.',
    areaRequired: 'أدخل المساحة أولاً.',
    areaInvalid: 'أدخل مساحة صحيحة أكبر من صفر.',
    resultTitle: 'العقارات بهذه المساحة في {{place}}',
    bandLabel: 'شريحة المساحة {{from}} - {{to}} م²',
    rangeTitle: 'نطاق سعر المتر لهذه الشريحة',
    typical: 'الوسيط',
    halfBetween: 'نصف الصفقات بين {{low}} و {{high}}',
    impliedTitle: 'ما يقابل مساحتك بهذه الأسعار',
    impliedNote: 'نطاق مبني على صفقات مسجّلة - ليس تقييماً لعقارك.',
    yourPrice: 'سعرك',
    premiumUp: 'هذه الشريحة أغلى بـ {{pct}}% من متوسط الحي للمتر',
    premiumDown: 'هذه الشريحة أرخص بـ {{pct}}% من متوسط الحي للمتر',
    premiumFlat: 'هذه الشريحة قريبة من متوسط الحي للمتر',
    cityFallback:
      'لا توجد صفقات كافية في هذا الحي وحده، فالنطاق محسوب على مستوى مدينة {{city}}.',
    outOfRange:
      'مساحتك خارج المساحات المسجّلة في هذا الحي، والنطاق المعروض هو أقرب شريحة متاحة.',
    allBands: 'كل شرائح المساحة في هذا الحي',
    position: {
      within: 'ضمن النطاق المعتاد',
      above: 'أعلى من معظم الصفقات المسجّلة',
      below: 'أقل من معظم الصفقات المسجّلة',
      withinNote: 'سعرك يقع داخل النطاق الذي سجّلته نصف صفقات هذه الشريحة.',
      aboveNote:
        'سعرك أعلى من النطاق الذي سجّلته نصف صفقات هذه الشريحة. قد يكون للعقار مزايا لا تظهر في بيانات الصفقات.',
      belowNote: 'سعرك أقل من النطاق الذي سجّلته نصف صفقات هذه الشريحة.',
    },
  },

  // ٣ — أفضل شهر للبيع
  month: {
    name: 'أفضل شهر للعرض',
    tagline: 'اختر مدينة، ونعرض لك الشهر الذي يكون فيه السوق أنشط.',
    cta: 'اعرض نشاط الأشهر',
    ctaAgain: 'اختر مدينة أخرى',
    howItWorks:
      'نحسب نصيب كل شهر من صفقات سنته، لا عدده المطلق - وإلا لبدا السوق النامي وكأن آخر الشهور هو الأنشط دائماً. والنتيجة متوسط عدة سنوات كاملة.',
    resultTitle: 'نشاط السوق خلال السنة في {{city}}',
    busiest: 'الأنشط',
    quietest: 'الأهدأ',
    busiestLine: '{{month}} هو أنشط شهر في {{city}} - صفقات أكثر بـ {{pct}}% من الشهر المتوسط.',
    quietestLine: '{{month}} هو الأهدأ، بأقل بـ {{pct}}% من المتوسط.',
    vsAverage: 'مقارنة بالشهر المتوسط',
    notClear: {
      title: 'لا يوجد فرق واضح بين الشهور',
      body:
        'الفروق بين شهور هذه المدينة صغيرة جداً، ولا تكفي لتوصية بشهر بعينه. توقيت العرض هنا لا يكاد يغيّر شيئاً.',
    },
    basedOnYears: 'بناءً على {{years}} سنوات كاملة و{{deeds}} صفقة',
    caveat:
      'هذا يقيس نشاط البيع (عدد الصفقات)، لا الأسعار. والتقويم ميلادي، فمواسم رمضان والحج تتحرك بين الشهور من سنة لأخرى.',
    months: {
      1: 'يناير',
      2: 'فبراير',
      3: 'مارس',
      4: 'أبريل',
      5: 'مايو',
      6: 'يونيو',
      7: 'يوليو',
      8: 'أغسطس',
      9: 'سبتمبر',
      10: 'أكتوبر',
      11: 'نوفمبر',
      12: 'ديسمبر',
    },
  },
};

export default marketTools;
